import { useTranslation } from "react-i18next";
import BtnCustom from "components/common/btn-custom";
import { ErrorToaster } from "components/common/toast";
import { useFormik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Container,
  UncontrolledTooltip,
} from "reactstrap";
import { successToaster } from "components/common/toast";
import handleError from "utils/handleError";
import CustomInputField from "components/common/CustomInputField";
import CustomPasswordField from "components/common/CustomPasswordField";
import { SettingsSchema } from "components/schema/SettingsSchema";
import { GetNotificationCredentials } from "network/wineDataSetAPI";
import { AddNotificationCredentials } from "network/wineDataSetAPI";
import { UpdateNotificationCredentials } from "network/wineDataSetAPI";
import { UserContextProvider } from "context/UserContext";

const Settings = () => {
  const { t } = useTranslation("account");
  const [credentials, setCredentials] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user } = useContext(UserContextProvider);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const response = await GetNotificationCredentials(user.uuid);
        if (response.success) {
          setCredentials(response?.data);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [user.uuid]);

  const {
    errors,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    isSubmitting,
  } = useFormik({
    initialValues: {
      sender_email: credentials?.sender_email || "",
      sender_email_password: credentials?.sender_email_password || "",
      receiver_email: credentials?.receiver_email || "",
      is_all_admin: credentials?.is_all_admin || false,
    },
    enableReinitialize: true,
    validationSchema: SettingsSchema,
    onSubmit: async (values) => {
      try {
        if (credentials?.uuid) {
          const response = await UpdateNotificationCredentials(
            user.uuid,
            values
          );
          if (response.success) {
            successToaster(t("settings.updated"));
          }
        } else {
          const response = await AddNotificationCredentials(values);
          if (response.success) {
            successToaster(t("settings.added"));
            setCredentials(values);
          }
        }
      } catch (error) {
        ErrorToaster(handleError(error?.status_code, error?.message));
      }
    },
  });
  return (
    <div className="content">
      <Container>
        <Row>
          <Col lg="12">
            <Card className="p-3">
              <CardHeader>
                <h3 className="title text-capitalize">
                  {t("settings.senderTitle")}
                </h3>
              </CardHeader>
              <Form onSubmit={handleSubmit}>
                <CardBody>
                  <Row>
                    <Col className="pr-md-1" md="6">
                      <CustomInputField
                        label={t("settings.senderEmail")}
                        name="sender_email"
                        placeholder={t("settings.senderEmailPlaceholder")}
                        type="Email"
                        errors={errors}
                        touched={touched}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values}
                      />
                    </Col>
                    <Col className="px-md-1" md="6">
                      <CustomPasswordField
                        label={t("settings.senderPassword")}
                        name="sender_email_password"
                        placeholder={t("settings.senderPasswordPlaceholder")}
                        type="password"
                        errors={errors}
                        touched={touched}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values}
                      />
                    </Col>
                    <UncontrolledTooltip
                      delay={0}
                      target="sender_email_password"
                    >
                      {t("settings.passwordTooltip")}
                    </UncontrolledTooltip>
                  </Row>
                  <Row>
                    <Col className="mb-4" md="12">
                      <h3 className="title text-capitalize mt-3">
                        {t("settings.notificationTitle")}
                      </h3>

                      <FormGroup check>
                        <Label check>
                          <Input
                            name="is_all_admin"
                            type="checkbox"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            checked={values.is_all_admin}
                          />
                          <span className="form-check-sign">
                            <span className="check" />
                          </span>
                          {t("settings.allAdmins")}
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col className="pr-md-1" md="12">
                      <CustomInputField
                        label={t("settings.recipients")}
                        name="receiver_email"
                        placeholder={t("settings.recipientsPlaceholder")}
                        type="textarea"
                        errors={errors}
                        touched={touched}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values}
                        disabled={values.is_all_admin}
                      />
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <BtnCustom
                    className="btn-fill"
                    color="primary"
                    type="submit"
                    submittingText={t("settings.saving")}
                    isLoading={isSubmitting}
                  >
                    {t("settings.save")}
                  </BtnCustom>
                </CardFooter>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Settings;
